// extracted by mini-css-extract-plugin
module.exports = {"logoPrimaryFill":"SafeLogo_logoPrimaryFill__wTkcq"};